/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Tab_Questions_AriaInputs */

const en_faq_tab_questions_aria = /** @type {(inputs: Faq_Tab_Questions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link to Questions`)
};

const fr_faq_tab_questions_aria = /** @type {(inputs: Faq_Tab_Questions_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lien vers les questions`)
};

/**
* | output |
* | --- |
* | "Link to Questions" |
*
* @param {Faq_Tab_Questions_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const faq_tab_questions_aria = /** @type {((inputs?: Faq_Tab_Questions_AriaInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Tab_Questions_AriaInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_tab_questions_aria(inputs)
	return fr_faq_tab_questions_aria(inputs)
});